import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'say-spritesheet',
    templateUrl: './spritesheet.component.html',
    styleUrls: ['./spritesheet.component.scss']
})
export class SpritesheetComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}